// Preis-Engine: unverbindliche Richtpreise inkl. Montage & MwSt. (solide Monteur-Mitte)
export const COLOR_FACTOR = {
  "Weiß RAL 9016": 1.0,
  "Anthrazitgrau RAL 7016": 1.08,
  "Verkehrsgrau RAL 7042": 1.08,
  "Schwarz RAL 9005": 1.08,
  "Holzdekor Golden Oak": 1.15,
  "Holzdekor Nussbaum": 1.15,
};

export const COLOR_HEX = {
  "Anthrazitgrau RAL 7016": "#3f454a",
  "Weiß RAL 9016": "#f2f2ef",
  "Verkehrsgrau RAL 7042": "#969ca1",
  "Schwarz RAL 9005": "#1c1e20",
  "Holzdekor Golden Oak": "#8a5a2b",
  "Holzdekor Nussbaum": "#5a3a22",
};

export const EXTRA_PRICES = {
  "Montage durch Ringel-Team": 0,
  "Entsorgung der Altelemente": 49,
  "Elektrischer Anschluss": 89,
  "Vermessung vor Ort": 0,
};

export const DIM_LIMITS = {
  "Fenster": { w: [400, 3000], h: [400, 2600], dw: 1200, dh: 1400 },
  "Haustüren": { w: [800, 1400], h: [1900, 2400], dw: 1000, dh: 2100 },
  "Rollläden": { w: [400, 3000], h: [400, 2600], dw: 1200, dh: 1400 },
  "Sonnenschutz": { w: [600, 6000], h: [400, 3000], dw: 3000, dh: 1600 },
  "Insektenschutz": { w: [400, 2000], h: [400, 2400], dw: 1000, dh: 1200 },
  "Wintergarten": { w: [2500, 8000], h: [2000, 3500], dw: 4000, dh: 2600 },
  "Vordächer": { w: [1000, 3000], h: [300, 1200], dw: 1600, dh: 700 },
  "Schiebetüren": { w: [1600, 6000], h: [1900, 2600], dw: 3000, dh: 2200 },
  "Garagentore": { w: [2000, 5500], h: [1900, 3000], dw: 2500, dh: 2125 },
  "Zäune": { dw: 25, dh: 0 },
  "Pergolen": { w: [2500, 7000], h: [2200, 3200], dw: 3600, dh: 2600 },
};

const FENCE_RATES = { "1,0 m": 89, "1,4 m": 99, "1,8 m": 119, "2,0 m": 139 };
const FENCE_TOR = { "Ohne Tor": 0, "Drehtor": 490, "Schiebetor (elektrisch)": 1890 };
const FENCE_LFM_EXTRA = {
  pfosten: { "Sichtbare Pfosten": 0, "Verdeckte Pfosten": 12 },
  fuellung: { "Volle Lamellen": 0, "Lamellen mit Glas-Element": 18 },
};

const area = (w, h) => (w / 1000) * (h / 1000);

// generische Aufpreis-Tabelle: {optionKey: {choice: aufpreis}}
const ADD = (table, o) => Object.entries(table).reduce((s, [key, map]) => s + (map[o[key]] || 0), 0);

const CALC = {
  "Fenster": (m2, o) => {
    const mat = { "Kunststoff": 1, "Kunststoff-Aluminium": 1.35, "Aluminium": 1.6 }[o.material] || 1;
    const glas = { "2-fach": 0, "3-fach (Wärmeschutz)": 45, "3-fach + Schallschutz": 95 }[o.verglasung] || 0;
    const oeff = { "Dreh-Kipp": 0, "Nur Dreh": -25, "Fest verglast": -60, "Zweiflügelig": 130 }[o.oeffnung] || 0;
    const add = ADD({
      griff: { "Abschließbarer Griff": 35, "Edelstahl-Griff": 45, "Design-Griff": 60 },
      dichtung: { "Premium schwarz": 25 },
      sprossen: { "Glasteilende Sprossen": 95, "Aufsatzsprossen": 65 },
      sicherheit: { "Pilzkopf-Verriegelung": 40, "RC2 einbruchhemmend": 120 },
    }, o);
    return (120 + 290 * m2 + glas + oeff + add) * mat;
  },
  "Haustüren": (m2, o) => {
    const base = { "Aluminium": 1590, "Kunststoff": 990 }[o.material] || 990;
    const seiten = { "Ohne": 0, "Links": 320, "Rechts": 320, "Beidseitig": 560 }[o.seitenteil] || 0;
    const add = ADD({
      griff: { "Stoßgriff": 90 },
      sicherheit: { "RC2 einbruchhemmend": 290 },
      schloss: { "Mehrfachverriegelung": 180, "Fingerscanner": 590 },
      schwelle: { "Barrierefrei (0 cm)": 95 },
      dichtung: { "Premium-Dreifachdichtung": 75 },
    }, o);
    return base + seiten + add;
  },
  "Rollläden": (m2, o) => {
    const antrieb = { "Elektrisch (Motor)": 110, "Gurtzug": 0, "Kurbel": 15 }[o.antrieb] || 0;
    const einbau = { "Vorsatz (sichtbarer Kasten)": 0, "Aufsatz (Neubau)": 30, "Unterputz": 60 }[o.einbau] || 0;
    const smart = { "Ohne": 0, "Mit Funksteuerung": 70, "Mit App-Steuerung": 120 }[o.smart] || 0;
    const add = ADD({
      behang: { "Aluminium-Behang": 60 },
      fuehrung: { "Gedämmte Führung": 35 },
    }, o);
    return 70 + 150 * m2 + antrieb + einbau + smart + add;
  },
  "Sonnenschutz": (m2, o) => {
    const art = { "Textilscreen (Zip)": 340, "Gelenkarm-Markise": 390, "Raffstore": 360 }[o.art] || 340;
    const antrieb = { "Motor": 130, "Manuell": 0 }[o.antrieb] || 0;
    const add = ADD({
      kassette: { "Kassette (geschlossen)": 190 },
      sensor: { "Windsensor": 95, "Wind + Sonne": 140 },
    }, o);
    return art + 180 * m2 + antrieb + add;
  },
  "Insektenschutz": (m2, o) => {
    const flat = { "Spannrahmen (Fenster)": 49 + 25 * m2, "Drehtür": 179, "Schiebeanlage": 239, "Plissee-Tür": 289 };
    const add = ADD({ gewebe: { "Pollenschutz": 25, "UV-beständig": 35 } }, o);
    return (flat[o.art] || 49) + add;
  },
  "Wintergarten": (m2, o) => {
    const glas = { "2-fach": 1, "3-fach (ganzjährig nutzbar)": 1.12 }[o.verglasung] || 1;
    const besch = { "Ohne": 0, "Dachmarkise": 490, "Unterdachmarkise": 390 }[o.beschattung] || 0;
    const add = ADD({
      boden: { "Gedämmter Boden": 450 },
      lueftung: { "Fensterlüfter": 120, "Dachlüfter motorisch": 390 },
    }, o);
    return (890 + 620 * m2) * glas + besch + add;
  },
  "Vordächer": (m2, o) => {
    const trag = { "Anthrazit-Stahl": 0, "Edelstahl": 140 }[o.tragwerk] || 0;
    const glas = { "VSG klar": 0, "VSG satiniert (milchig)": 60 }[o.glas] || 0;
    const add = ADD({
      beleuchtung: { "LED-Spots integriert": 145 },
      entwaesserung: { "Regenrinne mit Rohr": 95 },
    }, o);
    return 340 + 260 * m2 + trag + glas + add;
  },
  "Schiebetüren": (m2, o) => {
    const sys = { "Hebe-Schiebe": [890, 460], "Parallel-Schiebe-Kipp": [690, 380] }[o.typ] || [890, 460];
    const fluegel = { "2-flügelig": 0, "3-flügelig": 340 }[o.fluegel] || 0;
    const glas = { "2-fach": 0, "3-fach": 55 * m2 }[o.verglasung] || 0;
    const add = ADD({
      griff: { "Griffmulde flächenbündig": 75, "Abschließbar": 95 },
      schwelle: { "0-cm barrierefrei": 120 },
    }, o);
    return sys[0] + sys[1] * m2 + fluegel + glas + add;
  },
  "Garagentore": (m2, o) => {
    const art = { "Sektionaltor": [1050, 55], "Rolltor": [990, 45], "Schwingtor": [790, 40] }[o.torart] || [1050, 55];
    const add = ADD({
      antrieb: { "Mit Motor & Handsender": 290 },
      daemmung: { "Gedämmt": 160 },
      griff: { "Drucktaster": 45, "Elektr. Schloss": 190 },
      schluepftuer: { "Schlupftür seitlich": 590, "Schlupftür im Tor": 690 },
      sichtfenster: { "Sichtfenster-Reihe": 240 },
    }, o);
    return art[0] + art[1] * m2 + add;
  },
  "Pergolen": (m2, o) => {
    const dach = { "Drehbares Lamellendach": 1, "Festverglasung": 1.15 }[o.dach] || 1;
    const seiten = { "Offen": 0, "Senkrecht-Screens": 290, "Glasschiebewände": 490 }[o.seiten] || 0;
    const add = ADD({
      licht: { "LED integriert": 450 },
      heizstrahler: { "1 Heizstrahler": 290, "2 Heizstrahler": 540 },
    }, o);
    return (2890 + 210 * m2) * dach + seiten + add;
  },
};

export function computePrice({ productName, width, height, opts, color, extras, fence }) {
  if (productName === "Zäune") {
    const len = parseFloat((fence?.length || "").replace(",", "."));
    if (!len || len <= 0) return null;
    const lfmExtra = Object.keys(FENCE_LFM_EXTRA).reduce((s, key) => s + (FENCE_LFM_EXTRA[key][opts[key]] || 0), 0);
    return Math.round(len * ((FENCE_RATES[fence.height] || 99) + lfmExtra) + (FENCE_TOR[opts.tor] || 0));
  }
  const calc = CALC[productName];
  const w = parseFloat(width);
  const h = parseFloat(height);
  if (!calc || !w || !h) return null;
  const m2 = area(w, h);
  let price = calc(m2, opts);
  price *= COLOR_FACTOR[color] || 1;
  price += (extras || []).reduce((sum, x) => sum + (EXTRA_PRICES[x] || 0), 0);
  return Math.round(price / 5) * 5;
}

export const fmtPrice = (n) => (n == null ? "–" : `ca. ${n.toLocaleString("de-DE")} €`);
